t = require('views/internal/teacup-with-helpers')('comment_options')

module.exports = t.renderable (canAddAttachments, hasTriggeredFullView) ->
  t.div '.comment-box-options', ->

    if hasTriggeredFullView
      if canAddAttachments
        t.a '.comment-box-options-item.js-comment-add-attachment', { href: '#', title: t.l('add-an-attachment-ellipsis') }, ->
          t.icon 'attachment'

      t.a '.comment-box-options-item.js-comment-mention-member', { href: '#', title: t.l('mention-a-member-ellipsis') }, ->
        t.icon 'mention'

    t.a '.comment-box-options-item.js-comment-add-emoji', { href: '#', title: t.l('add-emoji-ellipsis') }, ->
      t.icon 'emoji'

    if hasTriggeredFullView
      t.a '.comment-box-options-item.js-comment-add-card', { href: '#', title: t.l('add-card-ellipsis') }, ->
        t.icon 'card'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/comment_options.coffee